import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {RaceAdditionalPricingItem} from "@model";
import {RaceCommercialService} from "@services";
import {inject} from "@angular/core";

export const EventAdditionalPricingItemsResolver: ResolveFn<Observable<RaceAdditionalPricingItem[]> | RaceAdditionalPricingItem[]> =
    (route: ActivatedRouteSnapshot,
     state: RouterStateSnapshot,
     raceCommercialService: RaceCommercialService = inject(RaceCommercialService)): Observable<RaceAdditionalPricingItem[]> | RaceAdditionalPricingItem[] => {
        if (+route.queryParams['eventId']) {
            return raceCommercialService.findEventAdditionalPricingItems(+route.queryParams['eventId'], true);
        } else {
            return [];
        }
    }